import { ParentFoodType, FoodDataType } from "models/Food";
import {
    EditableExcel,
    GetExcelResponse,
    SubmitBundleFormTypes,
    UpdatedExcelBody,
} from "./Food.props";
import api from "../API";
import { BundleDataType } from "models/Bundle";
import { ListResponseType } from "Services/Share.props";
import { ENDPOINTS } from "Services/Endpoints";

export const getFoodById = (id: string | undefined) => {
    return api.get<ParentFoodType>(`admin/food/${id}`);
};

export const getBundleFoodById = (id: string | undefined) => {
    return api.get<BundleDataType>(`admin/bundle/${id}`);
};

export const createFood = (data: any) => {
    return api.post("admin/food", data);
};
export const deleteFood = (id: any) => {
    return api.delete(`admin/food/${id}`);
};
export const deleteBundleFood = (id: any) => {
    return api.delete(`admin/bundle/${id}`);
};
export const restoreFood = (id: any) => {
    return api.post(`admin/food/${id}`);
};
export const restoreBundleFood = (id: any) => {
    return api.post(`${ENDPOINTS.BUNDLE}/${id}`);
};

export const updatedExcel = ({ vendorId, type, file }: UpdatedExcelBody) => {
    return api.put(`${ENDPOINTS.UPDATED_EXCEL}/${type}/${vendorId}`, file, {
        headers: {
            "Content-Type": "multipart/form-data",
            Accept: "*/*",
            "Accept-Encoding": "gzip,deflate",
        },
    });
};
export const changeFoodOrder = ({
    params,
    body,
}: {
    params: any;
    body: any;
}) => {
    return api.put(`admin/food/sort`, body, { params });
};

export const updateFood = (data: any) => {
    return api.put("admin/food", data);
};

export const getFoodExcel = () => {
    return api.get<GetExcelResponse>("admin/food-excel-generate");
};

export const getEditableExcel = ({ vendorId, type }: EditableExcel) => {
    return api.get<GetExcelResponse>(
        `admin/editable-excel-generate?vendor_id=${vendorId}&type=${type}`
    );
};

export const getBundleList = (params: any) => {
    return api.get<ListResponseType<BundleDataType>>(`admin/bundle`, {
        params,
    });
};

export const getFoodByVendorId = (vendorId: number | undefined) => {
    return api.get<ListResponseType<FoodDataType>>(
        `admin/food?vendor_id=${vendorId}&page_size=10000&trashed=1`
    );
};

export const submitBundle = ({
    data,
    isUpdate,
}: {
    data: SubmitBundleFormTypes;
    isUpdate: boolean;
}) => {
    if (isUpdate) {
        return api.put(`admin/bundle`, data);
    }
    return api.post(`admin/bundle`, data);
};

export const getFoodsExcel = () => {
    return api.get(`/admin/food-excel-generate`);
};

const FoodService = {
    getFoodById,
    createFood,
    updateFood,
};

export default FoodService;
